import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import ModalComponent from "./Modal";

const PdpTermsActions = ({ productDetails, placement }) => {
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("instr");
  const translation = getTranslationData();
  const isBelowAmount = placement === "below-amount";

  const handleClose = () => setShowModal(false);
  const handleShow = (event, tab) => {
    event.preventDefault();
    setActiveTab(tab);
    setShowModal(true);
  };

  useEffect(() => {
    document.body.classList.toggle("no-scroll", showModal);
    return () => document.body.classList.remove("no-scroll");
  }, [showModal]);

  return (
    <div
      className={`pdp-terms-slot pdp-terms-slot--${placement} ${
        isBelowAmount ? "d-none" : ""
      }`}
    >
      {showModal && (
        <ModalComponent
          productDetails={productDetails}
          show={showModal}
          modalClass="termsModal cc-pdp-terms-modal"
          modalRootClass="cc-pdp-terms-modal-root"
          handleClose={handleClose}
          activeTab={activeTab}
        />
      )}

      <div className="d-grid gap-2 imp-btns d-flex justify-content-start mt-4">
        <Link
          className="de-counterins pdp-terms-control"
          onClick={(event) => handleShow(event, "instr")}
        >
          <span className="pdp-terms-label">
            {translation?.importantInstructions}
          </span>
        </Link>
        <Link
          className="de-counterins pdp-terms-control"
          onClick={(event) => handleShow(event, "redeem")}
        >
          <span className="pdp-terms-label">{translation?.how_to_use}</span>
        </Link>
      </div>

      <div className="text-center">
        <Link
          className="tnc-link pdp-terms-control"
          onClick={(event) => handleShow(event, "terms")}
        >
          <span className="pdp-terms-label">
            {translation?.terms_condition}
          </span>
        </Link>
      </div>
    </div>
  );
};

export default PdpTermsActions;
